"use client"

import { useState } from "react"
import { useCurrency, type Currency } from "@/lib/currency-context"
import { useLanguage, type Language } from "@/lib/language-context"
import { ChevronDown } from "lucide-react"

export const REGIONS: { name: string; value: Currency }[] = [
  { name: "India (INR ₹)", value: "INR" },
  { name: "Germany (EUR €)", value: "EUR" },
  { name: "United States (USD $)", value: "USD" },
  { name: "United Kingdom (GBP £)", value: "GBP" },
  { name: "Canada (CAD $)", value: "CAD" },
]

export const LANGUAGES: { name: string; value: Language }[] = [
  { name: "English", value: "en" },
  { name: "German", value: "de" },
  { name: "French", value: "fr" },
  { name: "Spanish", value: "es" },
  { name: "Hindi", value: "hi" },
]

export function HeaderClientSelectors() {
  const { currency, setCurrency } = useCurrency()
  const { language, setLanguage } = useLanguage()

  const [showRegionDropdown, setShowRegionDropdown] = useState(false)
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false)

  const regions = REGIONS
  const languages = LANGUAGES

  return (
    <>
      {/* Region Selector */}
      <div className="relative">
        <div
          role="button"
          tabIndex={0}
          className="flex items-center gap-1 hover:opacity-80 transition-opacity cursor-pointer select-none"
          onClick={() => {
            setShowRegionDropdown(!showRegionDropdown)
            setShowLanguageDropdown(false)
          }}
        >
          {regions.find((r) => r.value === currency)?.name}
          <ChevronDown className={`h-4 w-4 transition-transform ${showRegionDropdown ? "rotate-180" : ""}`} />
        </div>
        {showRegionDropdown && (
          <div className="absolute right-0 top-full mt-2 bg-white text-gray-800 rounded shadow-lg py-2 min-w-48 z-10">
            {regions.map((region) => (
              <button
                key={region.value}
                onClick={() => {
                  setCurrency(region.value)
                  setShowRegionDropdown(false)
                }}
                className={`block w-full text-left px-4 py-2 hover:bg-muted text-sm ${currency === region.value ? "bg-accent/20 font-semibold" : ""}`}
              >
                {region.name}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Language Selector */}
      <div className="relative">
        <div
          role="button"
          tabIndex={0}
          className="flex items-center gap-1 hover:opacity-80 transition-opacity cursor-pointer select-none"
          onClick={() => {
            setShowLanguageDropdown(!showLanguageDropdown)
            setShowRegionDropdown(false)
          }}
        >
          {languages.find((l) => l.value === language)?.name}
          <ChevronDown className={`h-4 w-4 transition-transform ${showLanguageDropdown ? "rotate-180" : ""}`} />
        </div>
        {showLanguageDropdown && (
          <div className="absolute right-0 top-full mt-2 bg-white text-gray-800 rounded shadow-lg py-2 min-w-40 z-10">
            {languages.map((l) => (
              <button
                key={l.value}
                onClick={() => {
                  setLanguage(l.value)
                  setShowLanguageDropdown(false)
                }}
                className={`block w-full text-left px-4 py-2 hover:bg-muted text-sm ${language === l.value ? "bg-accent/20 font-semibold" : ""}`}
              >
                {l.name}
              </button>
            ))}
          </div>
        )}
      </div>
    </>
  )
}
